import React from "react";
import Navbar from "../components/navbar";
import Footer from "../components/Footer";
import "./BlogPage.css";
import blogScroll from "../assets/croppedscroll.png"; // example scroll bg

const blogPosts = [
  {
    id: 1,
    title: "Coming to the end of Initial Development",
    excerpt: "Explore how I built this app...",
    date: "July 27, 2025"
  },
  {
    id: 2,
    title: "Plans for improvement and future releases..",
    excerpt: "WHat will change in the coming months",
    date: "July 27, 2025"
  },

];

export default function BlogPage() {
  return (
    <>
      <Navbar />
      <div
        className="blog-page medieval-root"
        style={{
          backgroundImage: `url(${blogScroll})`,
          backgroundSize: "cover",
          backgroundPosition: "center"
        }}
      >
        <h1 className="medieval-logo" style={{ marginBottom: 20 }}>The Dev Blog</h1>
        <div className="blog-scroller">
          {blogPosts.map((post) => (
            <div key={post.id} className="blog-card medieval-text">
              <h3>{post.title}</h3>
              <span className="blog-date">{post.date}</span>
              <p>{post.excerpt}</p>
              <a href={`/blog/${post.id}`} className="medieval-btn ghost read-more">Read More</a>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
}
